import React, {Component} from 'react';
import SideBar from '../sidebar/sidebar';
import TopMenu from '../topMenu/topMenu';
import NameLinks from '../name/name';
import Panel from '../panel/panel';

class Portfolio extends Component {
  render() {
    const portfolioStyle = {
      position: 'fixed',
      backgroundImage: 'url(https://res.cloudinary.com/momojunzi/image/upload/v1537494203/background1_fadvr9.svg)',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      width: '100vw',
      height: '100vh',
      overflow: 'scroll'
    }
    return (
      <div style={portfolioStyle}>
        <TopMenu />
        <NameLinks />
        <Panel />
      </div>
    )
  }
}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/components/portfolio/portfolio.js